import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, NgZone } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { ValidationMessage } from 'app/validation';
import { Observable } from 'rxjs';
import { ProgramService } from 'app/client-core/services/program.service';
import { DropzoneComponent, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ApiService } from 'app/client-core/api.service';
import * as moment from 'moment';
import { NotificationService } from '../utils/notification.service';
import { RetailerProfileDocDto } from 'app/client-core/dtos/retailers.model';
import { RetailerService } from 'app/client-core/services/retailer.service';
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  maxFilesize: 50,
  acceptedFiles: '*'
};

@Component({
  selector: 'new-profile-version',
  templateUrl: './retailer-profile-new-version.component.html',
  styleUrls: ['./retailer-profile-new-version.component.scss']
})
export class NewProfileVersionComponent implements OnInit, OnChanges {
  @Input() requestId: number;
  @ViewChild('drpzone') drpzone: DropzoneComponent;
  ready: boolean;
  validationMessages: any;
  @Input() dto: RetailerProfileDocDto = {} as RetailerProfileDocDto;
  submitted: boolean;
  files: File[] = [];
  columns = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "name", name: "Name", flexGrow: 3 },
  ]);
  config: any;
  currentDate=moment().toDate();
  saving: boolean;

  constructor(
    private layoutService: LayoutService,
    public programService: ProgramService,
    private zone: NgZone,
    private apiService: ApiService,
    private notificationService: NotificationService,
    private retailerService: RetailerService
  ) {
    const self = this;
    this.config = {
      autoProcessQueue: false,
      acceptedFiles: '*',
      uploadMultiple: true,
      addRemoveLinks: true,
      dictDefaultMessage: 'Click or drop files here',
      init: function() {
        var drop = this;
        this.on('addedfile', function(file) {
          self.zone.run(() => {
            console.log(file);
            self.files.push(file);
          })
        });

        this.on('removedfile', function(file) {
          self.zone.run(() => {
            self.files = drop.files;
          })
        });
      }
    };
  }

  ngOnInit(): void {
    this.ready = true;
  }

  onUploadSuccess() {

  }

  onUploadError() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    
  }

  closeModal() {
    this.dto = {} as RetailerProfileDocDto;
    this.files = [];
    this.submitted = false;
    this.drpzone.directiveRef.reset();
    this.layoutService.hideSideModal.next();
  }

  canSubmit() {
    return true;
  }

  onSubmit() {
    this.submitted = false;
    this.saving = true;
    if (!this.canSubmit()) {
      this.validationMessages = new ValidationMessage(null, true, "There are some validation errors.");
      this.submitted = true;
      this.saving = false;
      return;
    }

    if (!this.files || this.files.length == 0) {
      this.notificationService.smartMessageBox({
        title: "",
        content: `You have not upload any files, are you sure you would like to continue?`,
        buttons: '[No][Yes]'
  
      }, (ButtonPressed) => {
          if (ButtonPressed == "Yes") {
            this.saveCommunicationRequest()
          } else {
            this.saving = false;
            this.submitted = false;
            return;
          }
      });
    } else {
      this.saveCommunicationRequest();
    }
  }

  saveCommunicationRequest() {
    let promisses = [];
    Promise.all(promisses).then(res => {
    this.programService.addNewVersion({
        nextVersionId: this.dto.nextVersionId,
        fileNames: this.files.map(f => f.name).join(','),
        requestId: this.dto.id
      }).subscribe(() => {
        this.saving = false;
        this.retailerService.retailerProfileDocAdded.next();
      })
    this.files.forEach(file => {
      promisses.push(this.apiService.uploadCommunicationRequestFile(file, this.dto.programId, this.dto.id, this.dto.nextVersionId));
    });
        this.validationMessages = new ValidationMessage(null, true, "File(s) upload success.").isSuccess();
        this.closeModal();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/retailer-profile-new-version/retailer-profile-new-version.component.ts